import React from 'react';
import styled from "styled-components";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-cards";
import "swiper/css/pagination";
import 'swiper/css/navigation'


import { Pagination, Navigation, Autoplay, EffectCards } from "swiper";

import img1 from "../Assets/images/nfts/nft1.svg"
import img2 from "../Assets/images/nfts/nft2.svg"
import img3 from "../Assets/images/nfts/nft3.svg"
import img4 from "../Assets/images/nfts/nft4.svg"
import img5 from "../Assets/images/nfts/nft5.svg"
import img6 from "../Assets/images/nfts/nft6.svg"
import img7 from "../Assets/images/nfts/nft7.svg"
import img8 from "../Assets/images/nfts/nft8.svg"
import img9 from "../Assets/images/nfts/nft9.svg"
import img10 from "../Assets/images/nfts/nft10.svg"

const Container = styled.div`
width: 25vw;
height: 70vh;

@media (max-width: 70em) {
    height: 60vh;
}

@media (max-width: 64em) {
    height: 50vh;
    width: 30vw;
}

@media (max-width: 48em) {
    height: 50vh;
    width: 40vw;
}

@media (max-width: 30em) {
    height: 45vh;
    width: 60vw;
}

.swiper {
    width: 100%;
    height: 100%;
}

.swiper-slide {
    background-color: ${props => props.theme.carouselColor};
    border-radius: 20px;

    display: flex;
    justify-content: center;
    align-items: center;
}

.swiper-button-next {
    color: ${props => props.theme.text};
    right: 0;
    background-image: url()
}

.swiper-button-prev {
    color: ${props => props.theme.text};
    right: 0;
    background-image: url()
}

img {
    width: 80%;
}
`

const Carousel = () => {
    return (
        <Container>
            <Swiper
                autoplay={{
                    delay: 2000,
                    disableOnInteraction: false,
                }}
                pagination={{
                    type:'fraction',
                }}
                modules={[EffectCards, Pagination, Navigation, Autoplay]}
                navigation={true}
                effect={"cards"}
                grabCursor={true}
                className="mySwiper"
            >
                <SwiperSlide> <img src={img1} alt="JollyShow" /> </SwiperSlide>
                <SwiperSlide> <img src={img2} alt="JollyShow" /> </SwiperSlide>
                <SwiperSlide> <img src={img3} alt="JollyShow" /> </SwiperSlide>
                <SwiperSlide> <img src={img4} alt="JollyShow" /> </SwiperSlide>
                <SwiperSlide> <img src={img5} alt="JollyShow" /> </SwiperSlide>
                <SwiperSlide> <img src={img6} alt="JollyShow" /> </SwiperSlide>
                <SwiperSlide> <img src={img7} alt="JollyShow" /> </SwiperSlide>
                <SwiperSlide> <img src={img8} alt="JollyShow" /> </SwiperSlide>
                <SwiperSlide> <img src={img9} alt="JollyShow" /> </SwiperSlide>
                <SwiperSlide> <img src={img10} alt="JollyShow" /> </SwiperSlide>
            </Swiper>
        </Container>
    )
}
export default Carousel;